import { computed } from 'mobx';
// import { computed, observable } from 'mobx';
// import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import $$tracker from '@src/tracker';

class AttentionStore {
  constructor(data) {
    this.mainStore = data.mainStore;
  }

  @computed
  get isActive() {
    return this.mainStore.pageChangeStore.currentPage === 'attention';
  }

  /** 打开预约弹窗 */
  onReservation = () => {
    if (this.mainStore?.projectConfig?.phone) return;
    $$tracker.clickReservation('底部');
    this.mainStore?.openReservationModal();
  };
}

export default AttentionStore;
